import { render, staticRenderFns } from "./txt-primary.vue?vue&type=template&id=b1cb7738&scoped=true&"
import script from "./txt-primary.vue?vue&type=script&lang=js&"
export * from "./txt-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cb7738",
  null
  
)

export default component.exports